<template>
  <v-app id="welcome-wrap">
    <!-- Header -->
    <header-welcome></header-welcome>

    <div class="sections">
      <div class="section-intro">
        <div class="header-title">공지사항</div>
      </div>

      <div class="section">
        <div class="section-title">
          2021년 8월 23일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            비블리오트리즈 상품 변경 안내
          </div>
          <div class="contents-text">
            <p>안녕하세요. 비블리오트리즈입니다.</p>
            <p>비블리오트리즈의 상품이 2021년 9월부터 아래와 같이 변경됩니다.</p>
          </div>
          <div class="contents-text">
            <p><b>상품이 '베이직(무료)'과 '프리미엄(유료)' 두 단계로 재편됩니다.</b></p>
            <p>베이직 회원은 랩에서 세 개의 프로젝트를 사용하실 수 있습니다.</p>
            <p>프리미엄 회원은 만들 수 있는 프로젝트의 개수 제한이 없으며,</p>
            <p>도큐먼트를 쉽게 보관할 수 있는 '도큐먼트 클립'과 내가 남긴 도큐먼트 리뷰를 모아보는 '리뷰 모아보기' 기능을 사용하실 수 있습니다.</p>
            <p>기존에 평생이용권을 구매하신 회원님들께는 프리미엄과 동일한 기능이 제공됩니다.</p>
          </div>
          <div class="contents-text">
            <p>기타 문의사항이 있으시면 services@bibliotrees.net 으로 연락주세요.</p>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          2020년 4월 25일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            비블리오트리즈 상품 변경 안내
          </div>
          <div class="contents-text">
            <p>안녕하세요. 비블리오트리즈입니다.</p>
            <p>비블리오트리즈의 상품이 2020년 7월부터 아래와 같이 개편될 예정이오니 이용에 참고하여 주시기 바랍니다.</p>
          </div>
          <div class="contents-text">
            <p><b>1. 상품 구매가 정기 구독으로 변경됩니다.</b></p>
            <p>연구 노트를 오랜 기간 보관하는 서비스의 특성상 기존의 단건 결제를 정기 결제로 전환합니다.</p>
            <p>정기 결제는 [계정 > 이용권 해지] 에서 언제든 해지할 수 있어 원하는 기간동안 상품을 이용하실 수 있습니다.</p>
            <p>이에 따라 <b>1년이용권 및 평생이용권 신규 가입이 종료</b>될 예정입니다.</p>
            <p>1년이용권을 구입하신 회원님께서는 종료일까지 이용권을 사용하실 수 있습니다.</p>
          </div>
          <div class="contents-text">
            <p><b>2. 월 정기결제 방법으로 카드 결제와 휴대폰 결제가 제공됩니다.</b></p>
            <p>결제 방법이 변경됨에 따라, 결제 수단 중 계좌이체는 사용할 수 없습니다.</p>
          </div>
          <div class="contents-text">
            <p>기타 문의사항이 있으시면 services@bibliotrees.net 으로 연락주세요.</p>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          2020년 4월 2일
        </div>
        <div class="section-contents">
          <div class="contents-title">
            비블리오트리즈 상업적 이용약관 변경 안내
          </div>
          <div class="contents-text">
            <p>안녕하세요. 비블리오트리즈입니다.</p>
            <p>비블리오트리즈를 이용해주셔서 감사합니다.</p>
            <p>보다 나은 서비스를 위해 상업적 이용약관이 아래와 같이 개정될 에정이오니 이용에 참고하여 주시기 바랍니다.</p>
          </div>
          <div class="contents-text">
            <p><b>변경 사유</b></p>
            <p>월단위 정기결제 상품이 추가될 예정임에 따라, 이를 반영하여 약관이 개정됩니다.</p>
          </div>
          <div class="contents-text">
            <p><b>변경 시기</b></p>
            <p>변경된 약관은 <b>2020년 5월 1일부터</b> 효력이 발생합니다.</p>
          </div>
          <div class="contents-text">
            <p><a href="/commercial-terms/20200501">새로운 약관 보기</a></p>
          </div>
          <div class="contents-text">
            <p>변경되는 비블리오트리즈 약관에 동의하지 않으시는 경우, 하단의 이메일을 통해 이의제기를 하실 수 있습니다.</p>
            <p>약관의 효력 발생일 전일까지 별도의 이의제기를 하지 않는 경우에는 본 변경에 동의한 것으로 판단되어 변경된 이용약관이 적용됩니다.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer-welcome></footer-welcome>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Whats-New"
    }
  },
}
</script>

<style scoped>
  .sections {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
    max-width: 1080px;
    margin: auto;
  }

  .section {
    margin-bottom: 1.5rem;
  }

  .header-title {
    padding: 40px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .section-title {
    padding: 12px 0;
    font-size: 22px;
    font-weight: 700;
  }

  .contents-title {
    padding: 20px 0 7px;
    font-size: 20px;
    font-weight: 700;
  }

  .contents-text {
    padding: 20px 0 7px;
  }

  .contents-list-title {
    padding: 7px 0;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/welcome/Notice.vue